import { atom, PrimitiveAtom, useAtom } from "jotai";

import { Api } from "interfaces";

import { useCreateProject } from "modules/projects/api";

import * as flowConfig from "flows/time-series/config";

import { useGetInputFile, useGetTimestamp } from "./store";
import { useCallback } from "react";
import { useUpdateAtom } from "jotai/utils";

const projectCreateStatus = atom<"not-started" | "in-progress" | "completed">(
  "not-started"
);

const projectCreateError = atom<string | Api.ApiError>(null) as PrimitiveAtom<
  string | Api.ApiError
>;

export const useGetCreate = () => {
  const createProject = useCreateProject();

  const inputFile = useGetInputFile();
  const timestamp = useGetTimestamp(inputFile);

  const [status, setStatus] = useAtom(projectCreateStatus);
  const [error, setError] = useAtom(projectCreateError);

  const create = useCallback(async () => {
    if (!inputFile || !timestamp) {
      setError("Input Data and Timestamp ARE BOTH MANDATORY!!!");
      return;
    }
    setStatus("in-progress");
    setError(null);
    const spec = {
      flow: flowConfig.FLOW_NAME,
      data_files: { [flowConfig.INPUT_DATA]: inputFile },
      meta_data: { [flowConfig.TIMESTAMP_VAR]: timestamp },
    };

    const resp = await createProject(spec);
    if (resp.success) {
    } else if (resp.success === false) {
      setError(resp.error);
    }
    setStatus("completed");
    return resp;
  }, [inputFile, timestamp]);

  return [create, status, error] as const;
};
